import styled, { css } from "styled-components";
import { theme } from "@Styled";

export const UrlLink = styled.a(
    () => css`
        color: ${theme.palette.common.deepSkyBlue};
        text-decoration: none;
        &:hover {
            text-decoration: underline;
        }
    `
);
